<template>
  <div v-if="!!values" class="form-group" role="group" :aria-labelledby="`legend-${data.id}`" :aria-describedby="fieldDescribedby">
    <slot/>
    <ul>
      <li
        class="form-group__field"
        v-for="(field, index) in data.options"
        :key="index">
        <form-item
          @fieldval="(data) => groupData(data)"
          :data="field"
          :input-value="values[field.id]"
          :type="data.type"/>
      </li>
    </ul>
    <p v-if="hasError" :id="`${data.id}-error`" class="field--error">
      <span v-for="(err, ind) in data.errors" class="field-help" :key="ind">{{ err.message }}</span>
    </p>
  </div>
</template>

<script>
  import FormItem from '@Feature/CustomForms/FormItem/code/Scripts/components/form-item';

  export default {
    name: 'form-group',

    components: { FormItem },

    props: {
      data: { type: Object, required: true, default: undefined },
      values: { type: [String, Boolean, Object], required: false, default: undefined },
    },

    data() {
      return {
        hasError: false,
        selectedItems: []
      };
    },

    computed: {
      isChecked() {
        return this.selectedItems.length > 0;
      },
      fieldDescribedby() {
        if (this.hasError) {
          return `${this.data.id}-error`;
        }
        return false;
      },
    },

    watch: {
      selectedItems() {
        if (this.data.required && this.selectedItems.length === 0) {
          this.hasError = true;
        } else {
          this.hasError = false;
        }

        this.emitChecked();
      }
    },

    mounted() {
      this.emitChecked();

      /* workaround to hide erros on mount for register form */
      this.$nextTick(() => {
        this.$parent.$vnode.componentOptions.tag === 'custom-form-register' ? this.hasError = false : false;
      });
    },

    methods: {
      emitChecked() {
        /* istanbul ignore else */
        if (this.data.required) {
          this.$emit('groupchecked', { group: this.data.id, checked: this.isChecked });
        }
      },
      groupData(payload) {
        const selected = this.selectedItems.findIndex(element => {
          /* istanbul ignore else */
          if (element.name === payload.name) {
            return true;
          } else {
            return false;
          }
        });

        selected === -1 ? this.selectedItems.push(payload) : this.selectedItems.splice(selected, 1);

        this.$emit('groupvalue', { ...payload, group: this.data.id });
      }
    }
  };
</script>

<style lang="scss">
</style>
